import React, {useState} from 'react';
import * as dateFns from 'date-fns';
import PropTypes from 'prop-types';

import {getTimeIntervals} from '../../services/helpers';
import TetherComponent from 'react-tether';
import OutsideClickHandler from '../common/OutsideClickHandler';
import TimeSlotMenu from "./TimeSlotMenuContainer";

const BodyTimeScale = (props) => {
  const {scroll, range, resources, onTimeCellClick, isSettings, startOfDay, endOfDay} = props;
  const interval = range || 0.5;
  const [availableTimeSlots] = useState(getTimeIntervals());
  const [openCell, setOpenCell] = useState(null);

  const handleCellClick = (resource, i) => {
    if (!isSettings) {
      setOpenCell({
        key: `timeslot_${resource.resourceId}_${i}`,
        resource,
        index: i,
      });
    }

    onTimeCellClick({
      resourceId: resource.resourceId,
      selectedTime: availableTimeSlots[Math.round(i * 12 * interval)].value,
    });
  };

  const timeScale = () => {
    let time = startOfDay;
    let hours = [];

    const differenceInTime = endOfDay - startOfDay;
    const timeSpots = differenceInTime / interval / (1000 * 60 * 60);
    if (dateFns.compareDesc(time, endOfDay) > 0) {
      for (let i = 0; i < timeSpots; i++) {
        hours.push(
          <div className="schedule-scale-row" key={i}>
            {resources.map((resource, ind) => {
              return (
                <TetherComponent
                  key={`${i}_${resource.resourceId}`}
                  attachment="middle right"
                  targetAttachment="top right"
                  constraints={[
                    {
                      to: "scrollParent",
                      attachment: "together",
                      pin: true,
                    },
                  ]}
                  renderTarget={(ref) => (
                    <div
                      ref={ref}
                      className="schedule-scale-cell"
                      onClick={() => handleCellClick(resource, i)}
                    />
                  )}
                  renderElement={(ref) =>
                    openCell?.key ===
                      `timeslot_${resource.resourceId}_${i}` && (
                      <div ref={ref} className="slot-menu menu open">
                        <OutsideClickHandler
                          handleClickOutside={() => setOpenCell(null)}
                          closeOnScroll
                        >
                          <TimeSlotMenu isDayPage={!isSettings} isClickedFromCell={true} />
                        </OutsideClickHandler>
                      </div>
                    )
                  }
                />
              );
            })}
          </div>
        );
        time = dateFns.addMinutes(time, interval * 60);
      }
    }
    return hours;
  };

  return (
    <div className="schedule-body-scale" style={{top: `-${scroll}px`}}>
      {timeScale()}
    </div>
  );
};

BodyTimeScale.propTypes = {
  resources: PropTypes.array,
  onTimeCellClick: PropTypes.func,
  startOfDay: PropTypes.number.isRequired,
  endOfDay: PropTypes.number.isRequired,
};

BodyTimeScale.defaultProps = {
  resources: [],
  onTimeCellClick: () => {
  },
};

export default BodyTimeScale;
